import { ReactNode } from 'react';
import clsx from 'clsx';
import './Card.css';

interface CardProps {
  children: ReactNode;
  className?: string;
  variant?: 'default' | 'glass' | 'gradient';
}

export function Card({ children, className, variant = 'default' }: CardProps) {
  return (
    <div
      className={clsx(
        'card',
        variant === 'glass' && 'card--glass',
        variant === 'gradient' && 'card--gradient',
        className
      )}
    >
      {children}
    </div>
  );
}
